<template lang="pug">
.listBox
  header.p-a-3.d-f.ai-c
    .title {{ title }}
    slot(name="header")
    .sorting.m-r-2.m-l-2(v-if="sortValues")
      div(@click="changeSorting")
        small(style="display: block") Sort on
        small(v-if="sortOn") {{ sortOn }}
      ul.sortValues(v-if="changingSorting", v-click-outside="changingSortingOutside")
        li(v-for="value in sortValues", :key="value", :class="{'selected': value == sortOn}", @click.prevent="changeSortOn(value)") {{ value }}
    .sort.mr-a(v-if="sort", @click="changeSort")
      small(style="display: block") Sort
        i.mdi(:class="{'mdi-menu-down': sorting == 'desc', 'mdi-menu-up': sorting == 'asc'}")
      small {{ (sorting == 'desc') ? 'Descending' : 'Ascending' }}
    .search.d-f.ai-c.m-l-2(v-if="search", :class="{'ml-a': (search && !pagination) || (search && pagination)}")
      ovp-input(placeholder="Search", @input="searchFunc")
    template(v-if="pagination")
      .pager.ml-auto.m-r-2(@click="prevPage")
        i(class="mdi mdi-chevron-left")
      .pages.m-r-2 {{ pageNumber }} of {{ maxPage }}
      .pager(@click="nextPage")
        i(class="mdi mdi-chevron-right")
  div
    slot
</template>

<script>
export default {
  props: ['title', 'link', 'pagination', 'maxPages', 'sort', 'sortValues', 'search'],
  data() {
    return {
      pageNumber: 1,
      maxPage: 1,
      sorting: 'desc',
      sortOn: null,
      changingSorting: false
    }
  },

  mounted() {
    if (this.maxPages) {
      this.maxPage = this.maxPages;
    }
    if (this.sortValues) {
      this.sortOn = this.sortValues[0];
    }
    if (this.sort) {
      this.sorting = this.sort;
    }
  },

  watch: {
    maxPages(val) {
      this.maxPage = val;
    },
    link: {
      handler(data) {
        this.calculatePages(data)
      },
      deep: true
    }
  },

  methods: {
    changeSortOn(val) {
      this.sortOn = val;
      this.$emit('sortOn', val);
      this.changingSorting = false;
    },
    searchFunc(val) {
      this.$emit('searching', val);
    },
    changingSortingOutside() {
      this.changingSorting = false;
    },
    changeSorting(val) {
      this.changingSorting = !this.changingSorting;
    },
    changeSort() {
      this.sorting = (this.sorting == 'desc') ? 'asc' : 'desc';
      this.$emit('sorting', this.sorting);
    },
    nextPage() {
      if (this.pageNumber >= this.maxPage) return;
      this.$emit('pagenumber', ++this.pageNumber);
    },
    prevPage() {
      if (this.pageNumber <= 1) return;
      this.$emit('pagenumber', --this.pageNumber);
    },

    calculatePages(data) {
      this.maxPage = 1;
      if (data.linkHeader != null) {
        let exploded = data.linkHeader.split(',');
        if (exploded[exploded.length-1].includes('rel="last"')) {
          let maxPage = parseInt(exploded[exploded.length-1].match(/(?:&page=|\?page=)(\d+)/)[1]); // + 1?
          this.maxPage = maxPage;
          if (maxPage < this.pageNumber) {
            this.pageNumber = maxPage;
            this.$emit('pagenumber', maxPage);
          }
        }
      }
    }
  }
}
</script>

<style lang="sass" scoped>
@import '../styles/variables.sass'

.extras
  width: 100%

header
  flex-wrap: wrap
  min-height: 62px

.listBox
  header
    background-color: rgba(64, 64, 121, 0.55)
    border-radius: 3px
    color: white
    font-size: 16px
.pager
  align-items: center
  border: 1px solid rgba(255, 255, 255, 0.15)
  border-radius: 10px
  display: inline-flex
  height: 20px
  justify-content: center
  transition: border-color .2s
  user-select: none
  width: 20px
  &:hover
    border-color: rgba(255, 255, 255, 0.5)
    cursor: pointer
.pages
  align-items: flex-end
  display: inline-flex
  font-size: 12px
  line-height: 18px

.sort,.sorting
  user-select: none
  &:hover
    cursor: pointer
  small
    font-size: 12px
    line-height: 12px

.sorting
  position: relative
  color: white
  .sortValues
    background-color: #2c2c54
    font-size: 12px
    position: absolute
    list-style: none
    top: 35px 
    left: -5px
    padding: 0
    border: 1px solid #373768
    border-top: 0
    min-width: 125px
    z-index: 2
    li
      padding: 5px
      &.selected
        color: darken(white, 40)
      &:hover
        background: rgba($mutedColor, 0.05)
        cursor: pointer
.search
  input
    border: 0
</style>

<style lang="sass">
.listBox .search
  input
    background-color: #2c2c54
    border: 0
    border-bottom: 1px solid #2c2c54
</style>
